import React from "react"
import MaterialIcon from "../material-icon/material-icon-view"
import styles from "./sort-indicator.module.scss"

interface SortIndicatorProps {
  display: boolean
  descending?: boolean
}

export const SortIndicator: React.FC<SortIndicatorProps> = ({display, descending}) => {
  if (!display) return null

  return <MaterialIcon name={descending ? "expand_less" : "expand_more"} className={styles.SortIndicator}/>
}
